import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

import { useSwitchOptimizerTabs } from './useChangeOptimizerTabs';
import { useSetSubscriptionLimits } from '../useSetSubscriptionLimits';

import {
    isCurrentAiProcessFinished,
    isCurrentAiProcessInProgress,
    showAiResultMessage,
} from '../../helpers/aiOptimizerHelpers';

import { aiInstanceTypes } from '../../../constants/aiOptimizerConstants';

import { selectCurrentBrief } from '../../../components/pages/contentOptimizer/contentPage/content/briefTab/content/tabsContent/store/contentBriefsOutline.selectors';
import useBriefVersions from '../../../components/pages/contentOptimizer/contentPage/content/briefTab/content/tabsContent/briefSummary/hooks/useBriefVersions';

export const useTrackProgressAIBrief = () => {
    const { switchToOptimizerBriefTab } = useSwitchOptimizerTabs();
    const { updateSubscriptionLimits } = useSetSubscriptionLimits();
    const { fetchBriefVersions } = useBriefVersions();

    const currentBrief = useSelector(selectCurrentBrief);

    const [showAiStatusMessage, setShowAiStatusMessage] = useState(false);

    const isAiBriefInProgress = useMemo(
        () => !!currentBrief && isCurrentAiProcessInProgress(currentBrief?.generation_status),
        [currentBrief]
    );

    useEffect(() => {
        if (!isAiBriefInProgress && showAiStatusMessage && currentBrief) {
            const { generation_status } = currentBrief;

            if (isCurrentAiProcessFinished(generation_status)) {
                showAiResultMessage(generation_status, aiInstanceTypes.BRIEF);
                setShowAiStatusMessage(false);
                updateSubscriptionLimits();
                switchToOptimizerBriefTab();
            }
        }
        // eslint-disable-next-line
    }, [isAiBriefInProgress, showAiStatusMessage, currentBrief]);

    useEffect(() => {
        if (isAiBriefInProgress) {
            setShowAiStatusMessage(true);

            const interval = setInterval(() => {
                fetchBriefVersions();
            }, 1000 * 5);

            return () => {
                clearInterval(interval);
            };
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isAiBriefInProgress]);
};
